import { Box } from '@offline-mui/material'
import { ReactNode } from 'react'
import { accountingUrl } from './api'

// Every Leo download (invoice PDF, reports, check files, imported files) goes through here: the file is fetched,
// named from the server's Content-Disposition when it is readable, else the given name, and saved.
export async function downloadFrom(path: string, fileName: string, failure: string) {
  const response = await fetch(accountingUrl(path))
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.message || failure)
  }
  const named = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') || '')?.[1]
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a')
  link.href = url
  link.download = named || fileName
  link.click()
  URL.revokeObjectURL(url)
}

// A download button or link's label. While the file is on its way a small "Downloading…" sits on top of the label; the
// label keeps its space (hidden) and the text takes none, so nothing around it moves.
export function DownloadLabel({ busy, children }: { busy: boolean; children: ReactNode }) {
  return (
    <Box component="span" sx={{ position: 'relative', display: 'inline-block' }}>
      <Box component="span" sx={{ visibility: busy ? 'hidden' : 'visible' }}>{children}</Box>
      {busy ? (
        <Box
          component="span"
          aria-label="Downloading"
          sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', fontSize: '0.75em', whiteSpace: 'nowrap', pointerEvents: 'none' }}
        >
          Downloading…
        </Box>
      ) : null}
    </Box>
  )
}
